import React, { Component } from "react";
import ContentLibraryService from "../../../services/contentLibraryService";
import ArticlePreview from "./ArticlePreview";
import connect from "react-redux/es/connect/connect";
import { ROLE_MPS_ADMIN } from "../../../security/roles";
import MPSBarLoader from "../../../components/MPSBarLoader";

class ArticlePreviewWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let { articleId, article } = this.props;
    if (article) {
      this.setState({ article });
    } else {
      this.setState({ loading: true });
      ContentLibraryService.loadArticle(articleId)
        .then(art => {
          this.setState({ article: art, loading: false });
        })
        .catch(e => {
          this.setState({ loading: false });
        });
    }
  }

  render() {
    let { loading, article } = this.state;

    if (loading) {
      return (
        <div style={{ margin: "100px auto", width: 100 }}>
          <MPSBarLoader />
        </div>
      );
    }

    if (!article) {
      return null;
    }

    let { userRole, packageId } = this.props;

    return (
      <ArticlePreview
        {...this.props}
        article={article}
        mps={userRole === ROLE_MPS_ADMIN}
        mpsPackageId={packageId}
        height={this.props.height}
        width={this.props.width}
      />
    );
  }
}

export default connect((state, ownProps) => {
  let libraries = state.mpsPackage.selectedPackage
    ? state.mpsPackage.selectedPackage.libraries
    : [];
  let articleId = ownProps.articleId;
  if (!articleId && ownProps.match && ownProps.match.params) {
    articleId = ownProps.match.params.articleId;
  }
  let index = libraries.findIndex(lib => lib.id === articleId);

  return {
    articleId: articleId,
    userRole: state.user.role,
    article: ownProps.article || libraries[index],
    packageId: state.mpsPackage.packageId
  };
})(ArticlePreviewWrapper);
